import { fetchClient } from "../lib/openapi-query";
import type { components } from "../types/generated/api";

export type Realm = components["schemas"]["Realm"];

export const RealmsService = {
  async getRealms(): Promise<Realm[]> {
    try {
      const response = await fetchClient.GET("/realms");
      if (response.error) {
        throw new Error("Failed to fetch realms");
      }
      return response.data || [];
    } catch (error) {
      console.error("Failed to fetch realms:", error);
      throw error;
    }
  },

  // Store the selected realm in localStorage
  setSelectedRealm(realmId: number): void {
    localStorage.setItem("selectedRealmId", realmId.toString());
  },

  getSelectedRealm(): number | null {
    const realmId = localStorage.getItem("selectedRealmId");
    return realmId ? Number(realmId) : null;
  },

  clearSelectedRealm(): void {
    localStorage.removeItem("selectedRealmId");
  },
};
